<template>
  <div v-if="visible" class="image-update-modal">
    <div class="modal-backdrop fade show" @click="$emit('close')"></div>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Detalle del producto</h5>
            <button type="button" class="btn-close" @click="$emit('close')"></button>
          </div>
          <div class="modal-body">
            <div class="product-box row w-100">
              <!-- Imagen principal (estilo prodectDetail) -->
              <div class="product-img col-lg-6">
                <div v-if="loadingProduct" class="text-center py-5 text-muted">
                  <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                  Cargando datos del producto...
                </div>
                <template v-else-if="product">
                  <img v-if="product.url" :src="product.url" alt="Producto" class="img-fluid rounded"
                    style="max-height: 280px; object-fit: contain" />
                  <div v-else class="text-muted py-5 text-center">Sin imagen</div>
                  <!-- Galería de resoluciones -->
                  <div v-if="product" class="product-thumbnails mt-3">
                    <h6 class="f-w-600 mb-2 small">Resoluciones disponibles</h6>
                    <div class="d-flex flex-wrap gap-2">
                      <a v-if="product.url128" :href="product.url128" target="_blank" class="thumbnail-link"
                        title="128x128">
                        <img :src="product.url128" alt="128" class="img-thumb" />
                        <span class="thumb-label">128</span>
                      </a>
                      <a v-if="product.url256" :href="product.url256" target="_blank" class="thumbnail-link"
                        title="256x256">
                        <img :src="product.url256" alt="256" class="img-thumb" />
                        <span class="thumb-label">256</span>
                      </a>
                      <a v-if="product.url512" :href="product.url512" target="_blank" class="thumbnail-link"
                        title="512x512">
                        <img :src="product.url512" alt="512" class="img-thumb" />
                        <span class="thumb-label">512</span>
                      </a>
                      <a v-if="product.url1024" :href="product.url1024" target="_blank" class="thumbnail-link"
                        title="1024x1024">
                        <img :src="product.url1024" alt="1024" class="img-thumb" />
                        <span class="thumb-label">1024</span>
                      </a>
                      <span v-if="!product.url128 && !product.url256 && !product.url512 && !product.url1024"
                        class="text-muted small">Ninguna</span>
                    </div>
                  </div>
                </template>
                <div v-else class="text-center py-5 text-muted">
                  No se encontraron datos del producto.
                </div>
              </div>
              <!-- Detalles (estilo prodectDetail) -->
              <div class="product-details col-lg-6">
                <template v-if="product">
                  <h4 class="mb-2">{{ product.producto }}</h4>
                  <div class="product-view mb-3">
                    <h6 class="f-w-600">Detalles del producto</h6>
                    <p class="mb-1 small text-muted">
                      <span class="f-w-600">Fecha de creación:</span> {{ formatDate(product.fecha) }}
                    </p>
                    <p v-if="product.fecha_Update" class="mb-1 small text-muted">
                      <span class="f-w-600">Última actualización:</span> {{ formatDate(product.fecha_Update) }}
                    </p>
                    <div class="product-size mt-2">
                      <h6 class="f-w-600 small mb-2">Estado por resolución</h6>
                      <ul class="list-unstyled d-flex flex-wrap gap-1 mb-0">
                        <li>
                          <span :class="statusBadge(product.url128)">128</span>
                        </li>
                        <li>
                          <span :class="statusBadge(product.url256)">256</span>
                        </li>
                        <li>
                          <span :class="statusBadge(product.url512)">512</span>
                        </li>
                        <li>
                          <span :class="statusBadge(product.url1024)">1024</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="product-qnty">
                    <h6 class="f-w-600">Actualizar imagen (.jpg)</h6>
                    <input type="file" accept=".jpg,image/jpeg" class="form-control mt-1" @change="onFileChange" />
                    <div v-if="previewUrl" class="mt-2">
                      <small class="text-muted d-block mb-1">Vista previa:</small>
                      <img :src="previewUrl" alt="Vista previa" class="img-preview rounded border" />
                    </div>
                    <small class="text-muted d-block mt-1">
                      El archivo debe llamarse exactamente <strong>{{ product.producto }}.jpg</strong>
                    </small>
                    <div class="addcart-btn mt-3">
                      <button type="button" class="btn btn-outline-secondary me-2" :disabled="loading"
                        @click="$emit('close')">
                        Cerrar
                      </button>
                      <button type="button" class="btn btn-primary" :disabled="!file || loading" @click="submit">
                        <template v-if="loading">
                          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Actualizando
                        </template>
                        <template v-else>Actualizar Imagen</template>
                      </button>
                    </div>
                  </div>
                </template>
                <div v-else class="text-muted small">
                  Esperando datos...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from "@/services/api";
import { toast } from "vue3-toastify";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

export default {
  name: "ImageUpdateModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** Código del producto (ej. "7501080122000") para consultar y actualizar */
    productCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      product: null,
      file: null,
      previewUrl: null,
      loading: false,
      loadingProduct: false,
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          document.body.classList.add("modal-open");
          if (this.productCode) {
            this.fetchProduct();
          }
        } else {
          document.body.classList.remove("modal-open");
          this.product = null;
          this.file = null;
          this.revokePreviewUrl();
        }
      },
      immediate: true,
    },
    productCode(val) {
      if (this.visible && val) {
        this.fetchProduct();
      }
    },
  },
  beforeUnmount() {
    document.body.classList.remove("modal-open");
    this.revokePreviewUrl();
  },
  methods: {
    async fetchProduct() {
      const code = this.productCode != null ? String(this.productCode) : "";
      if (!code) return;
      this.loadingProduct = true;
      this.product = null;
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://localhost:3000";
      try {
        const response = await apiFetch(
          `${baseUrl}/api/imagenes/${encodeURIComponent(code)}`,
        );
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.message || `Error HTTP ${response.status}`);
        }
        this.product = await response.json();
      } catch (error) {
        console.error("Error al cargar producto:", error);
        alert("No se pudieron cargar los datos del producto.");
        this.$emit("close");
      } finally {
        this.loadingProduct = false;
      }
    },
    formatDate(value) {
      if (!value) return "";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return value;
      return d.toLocaleString();
    },
    statusBadge(url) {
      return url
        ? "badge bg-success-subtle text-success me-1"
        : "badge bg-light text-muted me-1";
    },
    revokePreviewUrl() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }
    },
    onFileChange(event) {
      const [file] = event.target.files || [];
      this.revokePreviewUrl();
      if (!file) {
        this.file = null;
        return;
      }
      if (
        file.type !== "image/jpeg" &&
        !file.name.toLowerCase().endsWith(".jpg")
      ) {
        alert("Solo se permiten archivos .jpg");
        event.target.value = "";
        return;
      }
      const expectedName = `${String(this.product?.producto ?? "")}.jpg`;
      const fileName = file.name.toLowerCase();
      const expectedNameLower = expectedName.toLowerCase();
      if (fileName !== expectedNameLower) {
        toast.error(`El nombre del archivo "${expectedName}" no coincide con el nombre del producto. Seleccionaste: "${file.name}"`, {
          hideProgressBar: true,
          autoClose: 2000,
          theme: "colored",
        });
        event.target.value = "";
        return;
      }
      this.file = file;
      this.previewUrl = URL.createObjectURL(file);
    },
    async submit() {
      if (!this.file || !this.product) return;

      this.loading = true;
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://localhost:3000";

      try {
        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("producto", this.product.producto);

        const response = await apiFetch(`${baseUrl}/api/imagenes`, {
          method: "POST",
          body: formData,
        });

        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.message || `Error HTTP ${response.status}`);
        }

        const producto = this.product.producto;
        this.$emit("updated");
        this.$emit("close");
        Swal.fire({
          icon: "success",
          title: "Imagen actualizada",
          text: data.message || `La imagen del producto ${producto} se actualizó correctamente.`,
          confirmButtonText: "Aceptar",
        });
      } catch (error) {
        console.error("Error al actualizar imagen:", error);
        Swal.fire({
          icon: "error",
          title: "No se pudo actualizar la imagen",
          text: error.message || "Intenta nuevamente.",
          confirmButtonText: "Aceptar",
          customClass: { container: "swal-sobre-modal" },
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.image-update-modal .modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999990;
}

.image-update-modal .modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 999991;
}

.product-thumbnails .thumbnail-link {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: inherit;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.25rem;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.product-thumbnails .thumbnail-link:hover {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}

.img-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 0.25rem;
}

.thumb-label {
  font-size: 0.65rem;
  font-weight: 600;
  margin-top: 0.15rem;
}

.img-preview {
  max-width: 120px;
  max-height: 120px;
  object-fit: contain;
  display: block;
}
</style>

<style>
/* El modal usa z-index 999991; el error se muestra con el modal abierto. */
.swal2-container.swal-sobre-modal {
  z-index: 1000000;
}
</style>
